'use client';

import React from 'react';

interface SmartLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href?: string;
  showLoader?: boolean;
  prefetch?: boolean;
  callback?: () => string;
}

export const SmartLink: React.FC<SmartLinkProps> = ({
  href,
  showLoader = true,
  prefetch = false,
  callback,
  children,
  ...rest
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();

    const finalHref = typeof callback === 'function' ? callback() : href;

    if (finalHref) {
      window.history.pushState(null, '', finalHref);
    }
  };

  const currentHref = typeof callback === 'function' ? callback() : href;

  return (
    <a href={currentHref ?? ''} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
};
